import { useState } from "react";
import { Link } from "react-router-dom";
import { Loader2, ArrowLeft, MailCheck } from "lucide-react";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AuthShell } from "@/components/auth/AuthShell";

export default function RecuperarPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [enviado, setEnviado] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      // Respuesta neutra anti-enumeración: el backend siempre responde igual.
      await api.post("/auth/solicitar-reset", { email });
    } catch (_e) {
      // Aun en error, mostramos el mensaje neutro (no revelar si el correo existe).
      console.debug("solicitar-reset (respuesta neutra):", _e?.response?.status);
    } finally {
      setLoading(false);
      setEnviado(true);
    }
  };

  if (enviado) {
    return (
      <AuthShell>
        <div data-testid="recuperar-enviado" className="text-center">
          <MailCheck className="mx-auto mb-3 h-10 w-10 text-emerald-500" />
          <h1 className="font-heading text-xl font-semibold text-slate-900">Revisa tu correo</h1>
          <p className="mt-2 text-sm text-slate-500">
            Si el correo está registrado, recibirás instrucciones para restablecer tu contraseña.
            El enlace expira en 1 hora.
          </p>
          <Link to="/login" data-testid="volver-login" className="mt-5 inline-flex items-center text-sm font-medium text-accent hover:underline">
            <ArrowLeft className="mr-1 h-4 w-4" /> Volver a iniciar sesión
          </Link>
        </div>
      </AuthShell>
    );
  }

  return (
    <AuthShell>
      <h1 className="font-heading text-2xl font-semibold tracking-tight text-slate-900">¿Olvidaste tu contraseña?</h1>
      <p className="mt-2 text-sm text-slate-500">
        Escribe tu correo y te enviaremos un enlace para restablecerla.
      </p>
      <form onSubmit={submit} className="mt-6 space-y-4">
        <div>
          <Label htmlFor="email" className="mb-1.5 block text-sm font-medium text-slate-700">Correo electrónico</Label>
          <Input id="email" data-testid="recuperar-email" type="email" value={email} required
            onChange={(e) => setEmail(e.target.value)} placeholder="tu@empresa.mx" autoComplete="username" />
        </div>
        <Button data-testid="recuperar-submit" type="submit" disabled={loading}
          className="w-full bg-primary hover:bg-sidebar-hover">
          {loading ? <Loader2 className="mr-2 h-4 w-4 animate-spin" /> : null}
          Enviar enlace
        </Button>
      </form>
      <p className="mt-6 text-center text-sm">
        <Link to="/login" className="font-medium text-accent hover:underline">Volver a iniciar sesión</Link>
      </p>
    </AuthShell>
  );
}
